import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { ServicoRadioterapiaCnesContextService } from '../servico-radioterapia/services/servico-radioterapia-cnes-context.service';
import { InstitutionalSignatureComponent } from '../../shared/components/institutional-signature/institutional-signature.component';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [InstitutionalSignatureComponent],
  templateUrl: './callback.component.html',
})
export class CallbackComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private servicoRadioterapiaCnesContext: ServicoRadioterapiaCnesContextService = inject(ServicoRadioterapiaCnesContextService);

  ngOnInit(): void {
    const irParaDestino = (path: string | null) => {
      void this.router.navigate(path ? [path] : ['/']);
    };

    // HU-00 (OQ-04) — aceite dos Termos de Uso vem antes da seleção de estabelecimento CNES.
    const resolverDestinoPosLogin = async (): Promise<string | null> => {
      if (this.authService.isTermoAceitePendente()) return '/termos';
      return firstValueFrom(this.servicoRadioterapiaCnesContext.resolvePostLoginNavigation());
    };

    if (this.authService.isAuthenticated() && this.authService.getUserInfo() !== null) {
      resolverDestinoPosLogin()
        .then(irParaDestino)
        .catch(() => irParaDestino(null));
      return;
    }

    // Processa o retorno do Keycloak (troca do código de autorização por tokens)
    this.authService
      .initOAuthFlow()
      .then(async () => {
        if (this.authService.isAuthenticated() && this.authService.getUserInfo() !== null) {
          irParaDestino(await resolverDestinoPosLogin());
        } else if (!this.authService.isAuthenticated()) {
          void this.router.navigate(['/login']);
        }
        // else: token Keycloak válido mas sem usuário local — /sem-acesso já foi acionado dentro de loadUserData
      })
      .catch(() => {
        void this.router.navigate(['/login']);
      });
  }
}
